<app-loader *ngIf="isDisabled"></app-loader>
<div class="card">
    <div class="card-header">
        <div class="row">
            <div class="col">Designation Wise Data ( {{selectedDate}}) 
                <!-- <label class="Label"
                    style="margin-left: 3%;">
                    Allow Future Date :
                    <input type="checkbox" name="admincharg" [(ngModel)]="allowFutureDate" ngbCheckbox (change)="ESS_SiteManpowerSummary()"/>
                </label> -->
            </div>
            <div class="col-auto"><span class="badge view" style="font-size: larger;height: auto;">Total:
                    {{this.TotalCount}}</span></div>
        </div>
    </div>
    <div class="card-body">
        <div class="card-body p-1" style="overflow: auto;">
            <table datatable class="customeDatatable table table-bordered">
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col" style="width: 200px;">Client Name</th>
                        <th scope="col" style="width: 200px;">Site Name </th>
                        <th scope="col">Designation Name </th>
                        <th scope="col">Duty Name</th>
                        <th scope="col">Shift Name</th>
                        <th scope="col">No Of Person</th>
                        <th scope="col" *ngIf="edit" [ngClass]="{'colHide': !this.common.PageRight.IsView}">View</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let element of Data; let i = index">
                        <th scope="row">{{ i + 1 }}</th>
                        <td style="width: 200px;">{{element.ClientGroupName}}</td>
                        <td style="width: 200px;">{{element.SiteName}}</td>
                        <td>{{element.DesignationName}}</td>
                        <td>{{element.DutyName}}</td>
                        <td>{{element.ShiftTitle}}</td>
                        <td class="right-align">
                            <span class="no-of-person">{{element.NoOfPerson }}</span>
                        </td>
                        <td *ngIf="edit" [ngClass]="{'colHide': !this.common.PageRight.IsView}">
                            <button type="button" class="btn btn-sm btn-outline-primary btn-custom-small"
                                (click)="DesignationWiseDetails(element)">
                                <i class="bi bi-eye"></i> View
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="card-footer">
        <div class="row">
            <div class="col">
                <div class="row">
                </div>
                <div class="row">
                </div>
            </div>
            <div class="col-auto">
                <button class="btn btn-sm btn-primary" name="sample" (click)="exportToExcel()"
                    style="visibility: hidden;">
                    <i class="bi bi-file-earmark-arrow-down" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Excel':'Loading...'}}
                </button>
                &nbsp;
                <button type="button" class="btn btn-sm btn-primary" [disabled]="isDisabled" (click)="Cancel()">
                    <i class="bi bi-x-lg" *ngIf="!isDisabled"></i>
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                        *ngIf="isDisabled"></span>
                    {{!isDisabled?'Cancel':'Loading...'}}
                </button>
            </div>
        </div>
    </div>
</div>